import React, { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../firebase/firebaseConfig';
import { useNavigate, Link } from 'react-router-dom';
import './login.css';

export default function Register() {
  const [nombre, setNombre] = useState('');
  const [email, setEmail] = useState('');
  const [email2, setEmail2] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [contrasena2, setContrasena2] = useState('');
  const [verPass, setVerPass] = useState(false);
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');

    const nombreTrim = nombre.trim();
    const emailTrim = email.trim();
    const email2Trim = email2.trim();

    if (!nombreTrim) {
      setError('El nombre completo es obligatorio.');
      return;
    }
    if (!emailTrim || !email2Trim) {
      setError('Debes ingresar y confirmar el correo electrónico.');
      return;
    }
    if (emailTrim !== email2Trim) {
      setError('Los correos electrónicos no coinciden.');
      return;
    }
    if (!contrasena || !contrasena2) {
      setError('Debes ingresar y confirmar la contraseña.');
      return;
    }
    if (contrasena.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres.');
      return;
    }
    if (contrasena !== contrasena2) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    setCargando(true);
    try {
      // 1. Crear usuario en Auth
      const cred = await createUserWithEmailAndPassword(
        auth,
        emailTrim,
        contrasena
      );
      const user = cred.user;

      // 2. Guardar documento en "usuarios"
      await setDoc(doc(db, 'usuarios', user.uid), {
        nombre: nombreTrim,
        email: user.email,
        rol: 'pendiente',        // luego el Owner lo cambia
        activo: true,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });

      // 3. Enviar a pantalla de pendiente / inicio
      navigate('/pendiente');
    } catch (err) {
      console.error(err);
      const code = err?.code || '';
      let msg = 'No se pudo crear la cuenta. Intenta nuevamente.';

      if (code === 'auth/email-already-in-use') {
        msg = 'Este correo ya está registrado.';
      } else if (code === 'auth/invalid-email') {
        msg = 'El correo electrónico no es válido.';
      } else if (code === 'auth/weak-password') {
        msg = 'La contraseña es muy débil. Usa al menos 6 caracteres.';
      }

      setError(msg);
    } finally {
      setCargando(false);
    }
  };

  return (
    <div
      className="login login--bg"
      style={{
        backgroundImage: "url('/letrero.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <header className="login__brand">
        <img src="/logo.png" alt="Palmarama" className="login__logo" />
        <h1>Crear nueva cuenta</h1>
        <p className="muted">Registro de personal y promotores</p>
      </header>

      <form className="login__form" onSubmit={handleRegister} noValidate>
        {error && <div className="alert">{error}</div>}

        <label className="field">
          <span>Nombre completo</span>
          <input
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            placeholder="Ej: Juan Pérez"
            autoComplete="name"
          />
        </label>

        <label className="field">
          <span>Correo electrónico</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="ejemplo@correo.com"
            autoComplete="email"
          />
        </label>

        <label className="field">
          <span>Confirmar correo electrónico</span>
          <input
            type="email"
            value={email2}
            onChange={(e) => setEmail2(e.target.value)}
            placeholder="Vuelve a escribir el correo"
            autoComplete="email"
          />
        </label>

        <label className="field">
          <span>Contraseña</span>
          <div className="passwrap">
            <input
              type={verPass ? 'text' : 'password'}
              value={contrasena}
              onChange={(e) => setContrasena(e.target.value)}
              placeholder="Mínimo 6 caracteres"
              autoComplete="new-password"
            />
            <button
              type="button"
              className="toggle"
              onClick={() => setVerPass((v) => !v)}
            >
              {verPass ? 'Ocultar' : 'Mostrar'}
            </button>
          </div>
        </label>

        <label className="field">
          <span>Confirmar contraseña</span>
          <div className="passwrap">
            <input
              type={verPass ? 'text' : 'password'}
              value={contrasena2}
              onChange={(e) => setContrasena2(e.target.value)}
              placeholder="Repite la contraseña"
              autoComplete="new-password"
            />
            <button
              type="button"
              className="toggle"
              onClick={() => setVerPass((v) => !v)}
            >
              {verPass ? 'Ocultar' : 'Mostrar'}
            </button>
          </div>
        </label>

        <button
          className="btn btn--primary"
          type="submit"
          disabled={cargando}
        >
          {cargando ? 'Creando cuenta…' : 'Crear usuario'}
        </button>

        <div className="login__links">
          <span>
            ¿Ya tienes cuenta? <Link to="/">Iniciar sesión</Link>
          </span>
        </div>
      </form>

      <footer className="login__foot">
        © {new Date().getFullYear()} Palmarama · Uso interno
      </footer>
    </div>
  );
}